import BettingPanel from './component';

export default BettingPanel;
